import { SwarmType } from '../enums';
import { DATA_TYPE, type DataTypeValue } from './enums';

export const VIBRATION_GRAPH_DATA_TYPES: ReadonlyArray<DataTypeValue> = [
    DATA_TYPE.VTOP,
    DATA_TYPE.FDOM,
    DATA_TYPE.ATOP,
    DATA_TYPE.VEFF,
    DATA_TYPE.VDV,
];

export const DUST_GRAPH_DATA_TYPES: ReadonlyArray<DataTypeValue> = [
    DATA_TYPE.PM10,
    DATA_TYPE.PM2P5,
    DATA_TYPE.FLOW,
    DATA_TYPE.RH,
    DATA_TYPE.TEMP,
];

export const SOUND_GRAPH_DATA_TYPES: ReadonlyArray<DataTypeValue> = [
    DATA_TYPE.LXEQ,
    DATA_TYPE.LXTMAX,
    DATA_TYPE.DAILY_VALUES,
    DATA_TYPE.LXN,
    DATA_TYPE.LXPEAK,
    DATA_TYPE.LDEN,
];

export const SWARM_TYPE_DATA_TYPES: Record<SwarmType, ReadonlyArray<DataTypeValue>> = {
    [SwarmType.Vibration]: VIBRATION_GRAPH_DATA_TYPES,
    [SwarmType.Air]: DUST_GRAPH_DATA_TYPES,
    [SwarmType.Sound]: SOUND_GRAPH_DATA_TYPES,
};
